import { useMutation } from '@tanstack/react-query'
import { MEMBER_ID_REGEX } from '@chillout/core'
import { supabase } from '../../../lib/supabase'

export interface CashierMemberProfile {
  id: string
  memberId: string
  firstName: string | null
  lastName: string | null
  email: string | null
  profilePhotoUrl: string | null
}

export class MemberNotFoundError extends Error {
  constructor() {
    super('member_not_found')
  }
}

async function searchMember(query: string): Promise<CashierMemberProfile> {
  const normalized = query.trim()
  const normalizedQuery = MEMBER_ID_REGEX.test(normalized)
    ? normalized.toUpperCase()
    : normalized

  const { data, error } = await supabase
    .from('member_profiles')
    .select('id, member_id, first_name, last_name, email, profile_photo_url')
    .or(`email.eq.${normalizedQuery},member_id.eq.${normalizedQuery}`)
    .eq('is_anonymised', false)
    .maybeSingle()

  if (error) throw error
  if (!data) throw new MemberNotFoundError()

  return {
    id: data.id,
    memberId: data.member_id,
    firstName: data.first_name,
    lastName: data.last_name,
    email: data.email,
    profilePhotoUrl: data.profile_photo_url,
  }
}

export function useMemberSearch() {
  return useMutation({ mutationFn: searchMember })
}